const CategoriesApiWrapper = (requests: any) => {
	return {
		getAllCategories: () => {
			return requests.get('/market/categories/all');
		},
		// getPopularCategories: () => {
		// 	return requests.get('/market/categories/popular/main'); // this is correct endpoint to get popular categories. Unfortunatly it is not supported by backend.
		// },
		getPopularCategories: (filter: string | undefined) => {
			return requests.get(`/market/categories`, {
				params: { filter },
			});
		},
		getSearchResult: (body: any) => {
			return requests.post('/market/events/quick-search', body);
		},
		getCategoriesDescriptions: (id: number) => {
			return requests.get(`/market/categories/descriptions?categoryIds=${id}`);
		},
	};
};

export default CategoriesApiWrapper;
